import { Button } from "@mui/material";
import { styled } from "@mui/system";

export const TableToolbarButton = styled(Button)(() => ({
  fontSize: "0.8125rem",
}));
